import { Theme as DefaultTheme } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';
import { Color } from 'shared/utils/colors';

const useStyles = makeStyles<DefaultTheme, { isMobile: boolean }>({
  dialogWrapper: {
    width: ' 100%',
    maxWidth: '800px',
    margin: '16px',
    maxHeight: '85vh',
    top: ({ isMobile }): number => (isMobile ? 0 : 40),
  },
  dialogTitle: {
    fontSize: '1.125rem',
    fontWeight: 600,
  },
  dialogHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '24px',
    alignItems: 'center',
    borderBottom: `thin solid ${Color.disabledGray}`,
  },
  dialogActions: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '24px',
    fontFamily: 'Archivo',
    border: `thin solid ${Color.disabledGray}`,
  },
  dialogContent: {
    marginRight: 5,
    maxHeight: '15rem',
    minHeight: '15rem',
    padding: '15px 10px 15px 30px',
    display: 'flex',
    overflow: 'hidden' as const,
    overflowY: 'auto' as const,
  },
  mainContent: {
    marginTop: 10,
    marginBottom: 20,
  },
  input: {
    width: '100%',
    boxSizing: 'border-box' as const,
    fontSize: '0.875rem',
    color: '#979797',
    '&.descriptionField .MuiOutlinedInput-multiline': {
      flexDirection: 'column',
      alignItems: 'end',
    },
    '& fieldset': {
      borderRadius: '4px',
    },
    '& .MuiFormHelperText-marginDense': {
      marginTop: '0.125rem',
      marginBottom: '0.5rem',
      lineHeight: 'initial',
    },
  },
  pad8: {
    paddingTop: 8,
  },
  mab10: {
    marginBottom: 10,
  },
  mat10: {
    marginTop: 10,
  },
  mab20: {
    marginBottom: 20,
  },
  mat20: {
    marginTop: 20,
  },
  buttonDense: {
    padding: '2px 24px',
  },
  charCount: {
    color: '#ccc',
    fontSize: '0.75rem',
    position: 'relative' as const,
    top: '8px',
    right: '4px',
    '&.error': {
      color: 'crimson',
    },
  },
  inputError: {
    fontSize: '0.625rem',
    display: 'inline-block',
    width: '100%',
    minHeight: '1rem',
    paddingLeft: 8,
    position: 'relative' as const,
    top: -4,
    visibility: 'hidden' as const,
  },
  errorMessage: {
    visibility: 'visible' as const,
    color: 'crimson',
  },
});

export { useStyles };
